import { render, staticRenderFns } from "./view-father.vue?vue&type=template&id=08583b6a&scoped=true&"
import script from "./view-father.vue?vue&type=script&lang=js&"
export * from "./view-father.vue?vue&type=script&lang=js&"
import style0 from "./view-father.vue?vue&type=style&index=0&id=08583b6a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08583b6a",
  null
  
)

export default component.exports